import React from 'react';
import ActionMenu from './ActionMenu';
import SafeIcon from '../common/SafeIcon';
import { getExpenseIcon } from '../utils/expenseIcons';
import { FREQUENCIES, formatCents, formatYmd } from '../utils/expenseMath';
import '../burn-icons.css';

const FREQUENCY_LABELS = Object.fromEntries(FREQUENCIES.map((item) => [item.id, item.label]));

function ExpenseRow({ expense, onEdit, onDelete }) {
  const { icon, tone } = getExpenseIcon(expense.name);
  return (
    <li className="burn-row">
      <span className={`burn-row-icon tone-${tone}`} aria-hidden="true">
        <SafeIcon icon={icon} size={16} />
      </span>
      <div className="burn-row-main">
        <span className="burn-row-name">{expense.name}</span>
        <span className="burn-row-sub">Next due {formatYmd(expense.nextDue)}</span>
      </div>
      <div className="burn-row-amount">
        <span className="burn-row-price">{formatCents(expense.amountCents)}</span>
        <span className="burn-row-sub">{FREQUENCY_LABELS[expense.frequency]}</span>
      </div>
      <ActionMenu
        label={`Actions for ${expense.name}`}
        items={[
          { label: 'Edit', onSelect: () => onEdit(expense) },
          { label: 'Delete', danger: true, onSelect: () => onDelete(expense) }
        ]}
      />
    </li>
  );
}

export default ExpenseRow;